var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('jds-loader',{staticClass:"list-loader",attrs:{"loading":_vm.loading}}):_vm._e(),_vm._v(" "),(_vm.callLogs.length === 0)?_c('call-logs-empty-view',{staticClass:"h-full"}):_c('call-logs-timeline-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }